
import { Observable } from 'rxjs/Observable';

export class SchemaPropertyNode {
    propName: string;
    propType: string;
    nodeLevel: number = 0;
    isRequired: boolean = false;
    propAttributes: { key: string, value: any }[] = [];
    properties: { key: string, value: SchemaPropertyNode }[] = [];

    isNotScalar() {
        return (this.propType === "object" || this.propType === "array");
    }
    isRootNode(){
        return this.nodeLevel===0;
    }

    getSchema(): any {
        let schemaDefinition = {
            "type": this.propType.toLowerCase()

        }

        this.propAttributes.forEach(attr => schemaDefinition[attr.key] = attr.value);
        let listOfPropertySchema = [];
        this.properties.forEach(prop => listOfPropertySchema.push({ key: prop.key, value: prop.value.getSchema() }));
        if (this.propType.toLowerCase() === "array") {
            schemaDefinition["items"] = listOfPropertySchema.map(item => item.value);
        }
        if (this.propType.toLowerCase() === "object") {
            schemaDefinition["required"] = this.properties.filter(item => item.value.isRequired).map(item => item.key)
            schemaDefinition["properties"] = {};
            listOfPropertySchema.forEach(item => schemaDefinition["properties"][item.key] = item.value);
        }
        return schemaDefinition;
    }
   importSchemaNodeFromJsonObject(jsonObject) {
        /* if(!jsonObject || jsonObject.constructor!= Object){
            Observable.throw("Invalid Json Object");
        } */
        let listOfSchemaItems = [];
        for (let objKey in jsonObject) {
            listOfSchemaItems.push({ key: objKey.toLowerCase(), value: this.VisitNode(objKey.toLowerCase(), jsonObject[objKey],this.nodeLevel+1) });
            this.properties=listOfSchemaItems;
        }
        
        //return returnSchema;
    }
    VisitNode(propertyName: string, jsonObject: any,nodeLevel:number): SchemaPropertyNode {

        if (jsonObject) {
            if (jsonObject.constructor == Array) {
                let listOfSchemaItems = [];
                //for (let item in jsonObject) {
                    listOfSchemaItems.push({ key:"0",value:this.VisitNode(listOfSchemaItems.length.toString(),jsonObject[0],nodeLevel+1)});
                //}
                
                let returnSchema = new SchemaPropertyNode();
                returnSchema.propType = "array";
                returnSchema.propName = propertyName.toLowerCase();
                returnSchema.properties = listOfSchemaItems;
                returnSchema.isRequired = listOfSchemaItems.length > 0;
                returnSchema.nodeLevel=nodeLevel;
                return returnSchema;
            }
            else if (jsonObject.constructor == Object) {
                let listOfSchemaItems = [];
                for (let objKey in jsonObject) {
                    listOfSchemaItems.push({ key: objKey.toLowerCase(), value: this.VisitNode(objKey.toLowerCase(), jsonObject[objKey],nodeLevel+1) });
                }
                let returnSchema = new SchemaPropertyNode();
                returnSchema.propType = "object";
                returnSchema.properties = listOfSchemaItems;
                returnSchema.propName = propertyName.toLowerCase();
                returnSchema.isRequired = true;
                returnSchema.nodeLevel=nodeLevel;
                return returnSchema;
            }
        }

        let returnSchema = new SchemaPropertyNode();
        returnSchema.propType =jsonObject===null?"string": typeof(jsonObject);
        returnSchema.propName = propertyName;
        returnSchema.isRequired = false;
        returnSchema.nodeLevel=nodeLevel;
        return returnSchema;
    }

    generateJsonObjectFromSchema(){
        let jsonObj:any=undefined;
        if(this.propType==="object"){
            jsonObj={ };
            this.properties.forEach(prop=>{
                jsonObj[prop.key]=prop.value.generateJsonObjectFromSchema();
            });
            return jsonObj;
        }
        if(this.propType==="array"){
            jsonObj=[];
            this.properties.forEach(prop=>jsonObj.push(prop.value.generateJsonObjectFromSchema()));
            return jsonObj;
        }
        if(this.propType==="string")
            {
            jsonObj="";
            }
        if(this.propType==="number"){
            jsonObj=0;
        }
        if(this.propType==="boolean"){
            jsonObj=false;
        }
        return jsonObj;
        
    }



}



export class propertyFormModel {

    propName: string;
    propType: string;
    isRequeried: boolean;
    description: string = "";
    formType: string;

    private _formTitle: string;
    public get formTitle(): string {
        return this.formType === "array" ? "Array Item Type" : "Property";
    }




}
export interface modalDialogEvent {
    doActionOnSuccessEvent(args:any);
    doActionOnDismissEvent();
}